import React from 'react'

import { useTheme } from 'styled-components/native'

import { LightbulbIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/LightbulbIcon'
import {
  InlineBanner,
  InlineBannerProps,
} from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/inlineBanner/InlineBanner'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'

export interface InlineInnovationBannerProps extends Omit<InlineBannerProps, 'backgroundColor' | 'textColor'> {
  iconColor?: string
  backgroundColor?: string
  textColor?: string
}

export const InlineInnovationBanner: React.FC<InlineInnovationBannerProps> = ({
  text,
  testId,
  backgroundColor,
  iconColor,
  textColor,
  trailingLink,
  marginTop,
  marginBottom,
  title,
}) => {
  const { colors } = useTheme() as ThemeType
  const { inlineInnovationBanner } = colors.components

  const icon = <LightbulbIcon size={15} fillColor={iconColor || inlineInnovationBanner.text} />
  return (
    <InlineBanner
      text={text}
      icon={icon}
      testId={testId}
      backgroundColor={backgroundColor || inlineInnovationBanner.background}
      textColor={textColor || inlineInnovationBanner.text}
      trailingLink={trailingLink}
      marginBottom={marginBottom}
      marginTop={marginTop}
      title={title}
    />
  )
}
